module.exports = __webpack_public_path__ + "static/media/artworx.0ccb3ba6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/orgs/artworx.png
// module id = 741
// module chunks = 0